// src/components/InfoCard.jsx
import React, { useState, useEffect, useRef } from "react";
import "../styles/variables.css";

const InfoCard = ({ img, superText, subtitle, text }) => {
  const ref = useRef(null);

  // 1) Stato separato: numero da animare e suffisso da appendere
  const [displayValue, setDisplayValue] = useState(0);
  const [suffix, setSuffix]         = useState("");
  const [hasAnimated, setHasAnimated] = useState(false);

  // 2) Al mount, estraiamo numero e suffisso (se presenti)
  useEffect(() => {
    const m = String(superText).match(/^(\d+)([+kh%])?$/);
    if (m) {
      setSuffix(m[2] || "");
    } else {
      // non è un numero con suffisso: mostriamo superText così com'è
      setDisplayValue(superText);
    }
  }, [superText]);

  // 3) IntersectionObserver + requestAnimationFrame per animare solo la parte numerica
  useEffect(() => {
    if (!ref.current || hasAnimated) return;

    const m = String(superText).match(/^(\d+)([+kh%])?$/);
    if (!m) return; // niente animazione se superText non è un numero

    const target   = parseInt(m[1], 10);
    const duration = 800; // durata in ms

    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed  = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased    = 1 - Math.pow(1 - progress, 3); // ease-out
      setDisplayValue(Math.floor(eased * target));

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        setDisplayValue(target);
        setHasAnimated(true);
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          requestAnimationFrame(step);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [superText, hasAnimated]);

  return (
    <div
      ref={ref}
      className="d-flex flex-column gap-4 p-4"
      style={{ height: "100%" }}
    >
      <div className="d-flex justify-content-center">
        {img && !superText ? (
          <img src={img} className="img-fluid info-card-img" alt="" />
        ) : superText ? (
          // qui ricomponiamo numero + suffisso
          <p className="text-center info-card-supertext">
            {displayValue}
            {suffix}
          </p>
        ) : null}
      </div>
      <div className="d-flex flex-column align-items-center gap-4">
        <h3 className="info-card-subtitle">{subtitle}</h3>
        {text && <p className="info-card-text">{text}</p>}
      </div>
    </div>
  );
};

export default InfoCard;
